import React, { useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import { useDoorCrewCard } from './DoorCrewCardContext';
import DropoffAssignedChip from './DropoffAssignedChip';
import SeatActions from './SeatActions';
import { DoorCrewSeat } from './types';
import EndingPickUpAssignedChip from "./EndingPickUpAssignedChip";

interface UnassignedSectionProps {
  seat: DoorCrewSeat;
  onDeleteSeat: () => void;
}

export default function UnassignedSection({ seat, onDeleteSeat }: UnassignedSectionProps) {
  const { onUpdateSeat } = useDoorCrewCard();

  const [editingNote, setEditingNote] = useState(false);
  const [noteValue, setNoteValue] = useState(seat.assignment_placeholder_note ?? '');
  const inputRef = useRef<HTMLInputElement>(null);

  const handleNoteBlur = () => {
    setEditingNote(false);
    onUpdateSeat(seat.id, {
      assignment_placeholder_note: noteValue.length ? noteValue : null,
    });
  };

  return (
      <div className="canvasser-line door-seat-fields">
          <div className="line-item extra-long">
              <span className="minor-title">Name</span>
              <span className="edit-toggle no-click seat-unassigned-label">--- unassigned ---</span>
          </div>

          <div className="line-item long">
              <span className="minor-title">Assignment Note</span>
              {!editingNote ? (
                  <span
                      className="edit-toggle"
                      onDoubleClick={() => {
                          setEditingNote(true);
                          setTimeout(() => inputRef.current?.focus(), 0);
                      }}
                      title="Double-click to edit"
                  >
            {noteValue?.length ? (
                <span className="primary-text">{noteValue}</span>
            ) : (
                <span className="seat-empty-value">Add a note about how to assign this seat.</span>
            )}
          </span>
              ) : (
                  <TextField
                      inputRef={inputRef}
                      size="small"
                      fullWidth
                      value={noteValue}
                      onChange={(e) => setNoteValue(e.target.value)}
                      onBlur={handleNoteBlur}
                      autoFocus
                      placeholder="Add a note about how to assign this seat."
                      variant="standard"
                  />
              )}
          </div>

          <div className="line-item seat-dropoff">
              <span className="minor-title">Dropoff</span>
              {seat.dropoff_lat && seat.dropoff_lon ? (
                  <DropoffAssignedChip seat={seat}/>
              ) : (
                  <span className="edit-toggle no-click seat-empty-value">Not assigned</span>
              )}
          </div>

          <div className="line-item seat-dropoff">
              <span className="minor-title">End of Shift Pickup</span>
              {seat.ending_pickup_lat && seat.ending_pickup_lon ? (
                  <EndingPickUpAssignedChip seat={seat}/>
              ) : (
                  <span className="edit-toggle no-click seat-empty-value">Not assigned</span>
              )}
          </div>

          <SeatActions seatId={seat.id} onDeleteSeat={onDeleteSeat} showUnassign={false}/>
      </div>
  );
}
